<template>
  <div class="wrap">
    <el-form :model="form" inline class="date-form">
      <el-form-item label=""  >
        <el-radio-group 
          v-model="form.shortcutsTime" 
          size="small" 
          class="date-radio"
          @change="shortcutsTimeChange"
        >
          <el-radio-button label="week">近一周</el-radio-button>
          <el-radio-button label="month">近一个月</el-radio-button>
          <el-radio-button label="year">近一年</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="form.daterange"
          size="small"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          class="date-select"
          :clearable="false"
          @change="getPersonalApprovalDetail"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div class="chart-wrap" ref="appprovalBar">
      <ECharts
        v-if="approvalDetailData.length"
        :options="options" 
        autoresize  
        class="chart"
      />
      <div v-else class="non-data">暂无数据</div>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll.js";
import "echarts/lib/component/dataZoom.js";
import "echarts/lib/component/toolbox.js";

export default {
  components: {
    ECharts
  },
  data() {
    return {
      form: {
        shortcutsTime: 'month',
        daterange: []
      },
      approvalDetailData: [],
      agreeNumData: [],
      refuseNumData: [],
      xAxisData: [],
      approvalTotal: '',
      screenMaxBarNum: 30,
    }
  },
  computed: {
    zoomEnd() {
      return Math.round((this.screenMaxBarNum / this.approvalDetailData.length) * 100)
    },
    dataZoom() {
      return this.screenMaxBarNum > this.approvalDetailData.length 
        ? null
        : [{
            show: true,
            start: 0,
            end: this.zoomEnd,
          },{
            type: 'inside',
            start: 0,
            end: this.zoomEnd
          }]
    },
    options() {
      return {
        title: {
          text: `审批总量: ${this.approvalTotal}`,
          top: 0,
          left: 10,
          textStyle: {
            fontSize: 12,
            color: '#222430',
            fontWeight: '400'
          }         
        },
        legend: {
          right: 130,
          data: ['同意数量', '拒绝数量'],
          itemHeight: 4,
          itemWidth: 12,
          textStyle: {
            fontSize: 12,
            color: '#606266',
          } 
        },
        color: ['#74A8F8', '#FFB777'],
        tooltip: {
          trigger: 'axis',
          axisPointer: {           
            type: 'shadow',
            shadowStyle: {
              color: '#6CADFD',
              opacity: 0.2
            }  
          }
        },
        toolbox: {
          show: true,
          right: 0,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            mark: {show: true},
            dataView: {show: true, readOnly: true},
            saveAsImage: {show: true}
          }
        },
        grid: {
          left: '10px',
          right: '10px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.xAxisData,
            axisLine: {
              lineStyle: {
                color: '#EBEEF5'
              }
            },
            axisLabel: {
              color: '#909399'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLine: {
              lineStyle: {
                color: '#EBEEF5'
              }
            },
            axisLabel: {
              color: '#909399'
            },
            splitLine: {
              lineStyle: {
                color: '#EBEEF5'
              }
            }
          }
        ],
        series: [
          {
            name: '同意数量',
            type: 'bar',
            stack: '审批数量',
            barWidth: '22',
            data: this.agreeNumData
          },
          {
            name: '拒绝数量',
            type: 'bar',
            stack: '审批数量',
            barWidth: '15',
            data: this.refuseNumData
          },
        ],
        dataZoom: this.dataZoom
      }
    }
  },
  created() {
    this.shortcutsTimeChange('month');
  },
  mounted() {
    const width = this.$refs['appprovalBar'].offsetWidth || this.$refs['appprovalBar'].clientWidth
    this.screenMaxBarNum = Math.round(width / 25)
  },
  methods: {
    shortcutsTimeChange(type) {
      const end = this.$dayjs().format('YYYY-MM-DD')
      const start = this.$dayjs().subtract(1, type).format('YYYY-MM-DD')
      this.form.daterange = [start, end]
      this.getPersonalApprovalDetail()
    },
    getPersonalApprovalDetail() {
      _api.dataCenter.personalApprovalDetail({
        start: this.form.daterange?.[0] ?? '',
        end: this.form.daterange?.[1] ?? ''
      })
        .then(data => {
          this.approvalDetailData = data || [];
          let refuseNumData = [], agreeNumData = [], xAxisData = [], approvalTotal = 0
          this.approvalDetailData.forEach(el => {
            refuseNumData.push(el.refuseNum);
            agreeNumData.push(el.agreeNum);
            xAxisData.push(el.time)
            approvalTotal += el.agreeNum + el.refuseNum
          })
          this.refuseNumData = refuseNumData;
          this.agreeNumData = agreeNumData;
          this.xAxisData = xAxisData;
          this.approvalTotal = approvalTotal;
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  .date-form {
    text-align: right;
    .date-radio {
      /deep/ .el-radio-button__inner {
        color: #606266;
      }
      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #1890FF;
        background-color: #F0F7FF;
        border-color:  #C9E4FF;
        box-shadow: unset;
      }
    }
    .date-select {
      width: 310px;
    }
  }
  .chart-wrap {
    .chart {
      width: 100%;
      height: 400px;
    }
    .non-data {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 400px;
    }
  }
}
</style>
<style lang="scss">
.el-picker-panel {
  /deep/ .el-date-table td.in-range div, .el-date-table td.in-range div:hover {
    background-color: #e4f1ff;
  }
  /deep/ .el-date-table td.start-date span {
    background-color: #66b1ff;
  }
  /deep/ .el-date-table td.end-date span {
    background-color: #66b1ff;
  }
}
</style>